import { ConsoleTracesPage } from "@/features/console/pages/TracesPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_modal/console/traces")({
  validateSearch: (search: Record<string, unknown>) => ({
    query_id: typeof search.query_id === "string" ? search.query_id : undefined,
    conversation_id:
      typeof search.conversation_id === "string" ? search.conversation_id : undefined,
  }),
  component: ConsoleTracesRoute,
});

function ConsoleTracesRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ConsoleTracesPage
      selection={
        search.query_id
          ? { query_id: search.query_id, conversation_id: search.conversation_id || null }
          : null
      }
      onSelect={(selection) =>
        void navigate({
          search: {
            query_id: selection.query_id,
            conversation_id: selection.conversation_id || undefined,
          },
        })
      }
    />
  );
}
